@if (item.title) {
    <vn-pc-component-header-v2 [item]="item" />
}
<ng-container *vnPageMatrix="item.item" />
